export const BUDGET = 'budget';
export const TOLERANCE = 'tolerance';
export const OVER = 'over';